module.exports = ".table-responsive-sm {\n  overflow-x: scroll !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/fondeadores/simulacion-esquema-ahorrador/simulacion-esquema-ahorrador.component.scss
// module id = ./src/app/administracion/fondeadores/simulacion-esquema-ahorrador/simulacion-esquema-ahorrador.component.scss
// module chunks = main